/**
 * Este componente siempre se tiene que cargar en cliente usando next/dynamic ya que setea el iframe con el origen de la pagina.
 */

const baseURL = process.env.INTEGRA_DOMAIN;

export function Viewer3D({ code = '' }) {
  const iframeUrl = `${window.location.origin}/assets-new/model-viewer/index.html?code=${code}&origin=${baseURL}`;

  return <iframe src={iframeUrl} className="h-full w-full border-0"></iframe>;
}
